module.exports = __webpack_public_path__ + "img/p1-desc@2x.7300ce46.jpg";